import React from "react";
import Fallback from "../../components/Fallback";

const Projects = React.lazy(() => import("./Projects"));
export const ProjectsScreen: React.FC<any> = (props) => (
  <React.Suspense fallback={<Fallback />}>
    <Projects {...props} />
  </React.Suspense>
);
